import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateIssueDownloadUrlInput,
  CreateIssueDownloadUrlResponse,
  QueryCreateIncidentIssueDocumentDownloadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateIncidentIssueDocumentDownloadUrlDocument } from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIssueDownloadUrlInput]?: CreateIssueDownloadUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIssueDownloadUrlResponse>;
}

// SearchIncidentIssueDocument Service
export const {
  createIncidentIssueDocumentDownloadUrl,
  recreateIncidentIssueDocumentDownloadUrl,
  useCreateIncidentIssueDocumentDownloadUrl,
} = ((): {
  createIncidentIssueDocumentDownloadUrl: ServiceMethod;
  recreateIncidentIssueDocumentDownloadUrl: ServiceMethod;
  useCreateIncidentIssueDocumentDownloadUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(CreateIncidentIssueDocumentDownloadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIssueDownloadUrlInput, options?: ConnectionOptions): Promise<CreateIssueDownloadUrlResponse> => {
        const args: QueryCreateIncidentIssueDocumentDownloadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createIncidentIssueDocumentDownloadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createIncidentIssueDocumentDownloadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createIncidentIssueDocumentDownloadUrl: fetch,
    recreateIncidentIssueDocumentDownloadUrl: refetch,
    useCreateIncidentIssueDocumentDownloadUrl: useService,
  };
})();
